<script setup lang="ts">
import { PrimaryButton } from '@/components/Buttons'
import { StackLayout } from '@/components/Layouts'
import FullScreenLoader from '@/components/LoadingSpinner/FullScreenLoader.vue'
import { BaseDialog } from '@/components/Modals/Dialog'
import organizationApi from '@/services/organization.service'
import store from '@/store'
import { EAlertActions } from '@/store/alertStore/AlertStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import TypographyItem from '../../../components/Typography/TypographyItem.vue'

type Props = {
    rentalId: number
}
const props = defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
const emit = defineEmits<Emits>()

const { t } = useI18n()

const organizationId = computed(() => store.state.authentication.me.organization_id)

const open = ref(false)
const isLoading = ref(false)

const confirmEndRental = () => {
    if (!organizationId.value) return
    isLoading.value = true
    organizationApi
        .endRental(organizationId.value, props.rentalId)
        .then(() => {
            open.value = false

            store.dispatch(`${EStoreModules.ALERT}/${EAlertActions.QUEUE_ITEM}`, {
                action: EAlertActions.SUCCESS,
                message: t('device.rental.endRentalApiSuccess')
            })

            setTimeout(() => emit('refresh'), 5000)
        })
        .finally(() => (isLoading.value = false))
}
</script>

<template>
    <FullScreenLoader :isLoading="isLoading" />
    <PrimaryButton
        :label="$t('device.rental.endCurrentRentalAction')"
        @click="open = true"
        v-bind="$attrs" />
    <BaseDialog
        :title="$t('device.rental.endCurrentRentalTitle')"
        :open="open"
        @close="open = false"
        @confirm="confirmEndRental">
        <template #content>
            <StackLayout direction="column" :gap="16" class="full-width">
                <TypographyItem :label="$t('device.rental.endCurrentRentalDescription')" />
            </StackLayout>
        </template>
    </BaseDialog>
</template>
